import { PluginKey } from "prosemirror-state";
const MENU_STATE_TOKEN = "toolbar-floating-menu-state";
const STATIC_MENU_STATE_TOKEN = "toolbar-static-menu-state";
export const floatingMenuPluginKey = new PluginKey(MENU_STATE_TOKEN);
export const staticMenuPluginKey = new PluginKey(STATIC_MENU_STATE_TOKEN);
export class MenuPluginState {
    init() {
        return { enabled: true };
    }
    apply(tr, value) {
        const update = tr.getMeta(MENU_STATE_TOKEN);
        if (update) {
            return { ...value, ...update };
        }
        return value;
    }
}
export function menuEnabled(state) {
    return floatingMenuPluginKey.getState(state).enabled;
}
export function disableMenu(tr) {
    return tr.setMeta(MENU_STATE_TOKEN, { enabled: false });
}
export function enableMenu(tr) {
    return tr.setMeta(MENU_STATE_TOKEN, { enabled: true });
}
